@import './src/scss/deps';

.countdown-container {
	display: flex;

	.countdown-label {
		font-size: 13px;
	}

	.countdown-separator {
		height: 60px;
		padding: 0 15px;
		line-height: 60px;
		color: var(--containerColor);
	}

	.countdown-number {
		color: var(--secondaryAccentColor);
	}
}

@mixin countdownResponsive {
	.countdown-container {
		.countdown-separator {
			height: 50px;
			padding: 0 10px;
			line-height: 50px;
		}
		.countdown-number {
			font-size: 40px;
		}
		.countdown-label {
			font-size: 12px;
		}
	}
}
@include media-query($sm-down) {
	@include countdownResponsive();
}
.editor.mobile {
	@include countdownResponsive();
}

@include auto-generated-pack {
	.countdown-container {
		.countdown-number {
			color: var(--labelOnBannerColor, var(--secondaryAccentColor));
		}
		.countdown-label {
			color: var(--labelOnBannerColor, var(--secondaryAccentColor));
		}
	}
}
